export function getDatabasePlatforms(): { [platform: string]: any } {
  return {
    iOS: { platform: "iOS", url: "../../assets/img/iphone-black.png" },
    Android: { platform: "Android", url: "../../assets/img/platformsLogos/android.png" },
    Chrome: { platform: "Chrome", url: "../../assets/img/platformsLogos/chrome.png" },
    Safari: { platform: "Safari", url: "../../assets/img/platformsLogos/safari.png" },
    Firefox: { platform: "Firefox", url: "../../assets/img/platformsLogos/firefox.png" },
    Edge: { platform: "Edge", url: "../../assets/img/platformsLogos/edge.png" },
  }
}
